import { z, type infer as zInfer } from "zod";

const racingFilters = z.object({
  page: z.coerce.number().default(1),
  regions: z.array(z.enum(["au", "world"])).default(["au", "world"]),
  titles: z
    .array(z.enum(["horse_racing", "greyhounds", "harness_racing"]))
    .optional(),
});

export { racingFilters };
